// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Tdz1a","left":"styles_left__3u55X"};